var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"notes",style:(_vm.open ? 'height: 276px' : 'height: 50px')},[_c('h3',{on:{"click":function($event){_vm.open = !_vm.open}}},[_vm._v("Notes")]),_c('textarea')])
}
var staticRenderFns = []

export { render, staticRenderFns }